(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        "use strict";
        var __webpack_exports__ = {};
        __webpack_require__.r(__webpack_exports__);
    }();
    !function() {
        (() => {
            $((() => {
                if (window.custom_buttons) {
                    return;
                }
                window.custom_buttons = true;
                const custom_buttons = $(".custom-buttons");
                if ($(custom_buttons).length > 0) {
                    const buttons_items = $(custom_buttons).find(".custom-buttons__item");
                    const cbs_init = $(".custom-bundle-shopping-init");
                    const cbs_title = $(".custom-buttons__title-text");
                    $(buttons_items).each(((index, item) => {
                        if ($(item).hasClass("action")) {
                            const ca = $(item).data("ca");
                            $.each(cbs_init, (function() {
                                if ($(this).data("category") === ca) {
                                    $(this).fadeIn(500);
                                }
                            }));
                        }
                        $(item).on("click", (function(e) {
                            e.preventDefault();
                            const ca = $(this).data("ca");
                            $(buttons_items).each((function() {
                                if ($(this).hasClass("action")) {
                                    $(this).removeClass("action");
                                }
                            }));
                            $(this).addClass("action");
                            $(cbs_title).text($(this).text());
                            $.each(cbs_init, (function(i, v) {
                                if ($(v).data("category") === ca) {
                                    $(v).fadeIn(500);
                                } else {
                                    $(v).fadeOut(500);
                                }
                            }));
                        }));
                    }));
                }
            }));
        })();
    }();
})();